/*
 * File: /src/store/modules/menuService.js
 * Created Date: Sunday May 12th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 12th May 2019 10:42:50 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import voiceService from '../../services/voiceServices';
import callPlanService from '../../services/callPlanServices';

const state = {
  callPlans: undefined,
  menus: undefined,
  voicemailBoxes: undefined,
  directDials: undefined,
};

const getters = {
  getCallPlans: state => {
    return state.callPlans;
  },
  getMenus: state => {
    return state.menus;
  },
  getVoicemailBoxes: state => {
    return state.voicemailBoxes;
  },
  getDirectDials: state => {
    return state.directDials;
  },
};
const actions = {
  async fetchCallPlans({ commit }) {
    if (state.callPlans == undefined) {
      return callPlanService.fetchCallPlans()
        .then(r => {
          commit('setCallPlans', r.data);
        });
    }
  },
  unloadCallPlans({ commit }) {
    commit('setCallPlans', undefined);
  },
  async fetchMenus({ commit }) {
    if (state.menus == undefined) {
      return voiceService.fetchMenus()
        .then(r => {
          commit('setMenus', r.data);
        });
    }
  },
  unloadMenus({ commit }) {
    commit('setMenus', undefined);
  },
  fetchVoicemailBoxes({ commit }) {
    if (state.voicemailBoxes == undefined) {
      return voiceService.fetchVoicemailBoxes()
        .then(r => {
          commit('setVoicemailBoxes', r.data);
        });
    }
  },
  unloadVoicemailBoxes({ commit }) {
    commit('setVoicemailBoxes', undefined);
  },
  fetchDirectDials({ commit }) {
    if (state.directDials == undefined) {
      return voiceService.fetchDirectDials()
        .then(r => {
          commit('setDirectDials', r.data);
        });
    }
  },
  unloadDirectDials({ commit }) {
    commit('setDirectDials', undefined);
  },
};
const mutations = {
  setCallPlans(state, d) {
    state.callPlans = d;
    // state.callPlans = Object.assign([], d);
  },
  setMenus(state, d) {
    state.menus = d;
    // state.menus = Object.assign([], d);
  },
  setVoicemailBoxes(state, d) {
    state.voicemailBoxes = d;
    // state.voicemailBoxes = Object.assign([], d);
  },
  setDirectDials(state, d) {
    state.directDials = d;
    // state.directDials = Object.assign([], d);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
